import Cookies from "js-cookie";

export const getLanguage = () => {
  if (typeof window === undefined) {
    return null;
  }
  return Cookies.get("language");
};
